import AdminHome from "../../components/ListUser/Home";

export default function Home() {
  return (
    <div><AdminHome /></div>
  );
}
